import { Paper, Typography } from '@mui/material';
import SimpleProfileCard from '../../components/SimpleProfileCard/SimpleProfileCard';

import './SimpleAgentUserCard.scss';

function SimpleAgentUserCard({ className, cityName, agentName, agentImageURL }) {
  const classes = `simple-agent-user-card ${className || ''}`;
  return (
    <div className={classes}>
      <Paper
        elevation={2}
        className="outter-container"
      >
        <SimpleProfileCard
          className="agent-user-card"
          userPictureURL={agentImageURL}
        />
        <div className="agent-info-container">
          <Typography variant="p" component="p" className="agent-name">{agentName}</Typography>
          <Typography variant="p" component="p" className="city">Agente de {cityName}</Typography>
        </div>
      </Paper>
    </div>
  );
}

export default SimpleAgentUserCard;
